import isPlainObject from 'lodash/isPlainObject'
import merge from 'lodash/merge'
import set from 'lodash/set'
import {
  formatDistanceToNowStrict,
  format,
  differenceInDays,
  isDate,
  parseISO,
} from 'date-fns'


export const isServer = typeof window === 'undefined'

export function flattenObject(
  _obj: Record<string, any>,
  _path: string[] = []
): Record<string, any> {
  const _flattenObject = (obj: Record<string, any>, path: string[]): Record<string, any> => {
    return !isPlainObject(obj)
      ? { [path.join('.')]: obj }
      : Object.entries(obj).reduce(
          (acc, [key, value]) => merge(acc, _flattenObject(value, [...path, key])),
          {}
        )
  }
  return _flattenObject(_obj, _path)
}

export function nestObject(_obj: Record<string, any>, _path: string[] = []): Record<string, any> {
  return Object.entries(_obj).reduce((acc, [key, value]) => set(acc, key, value), {})
}

export const formatDate = (date: string | Date, formatString = 'PPP') => {
  try {
    let parsedDate
    if (isDate(date)) parsedDate = date as Date
    else parsedDate = parseISO(date as string)
    return format(parsedDate, formatString)
  } catch (err) {
    return 'Invalid Date'
  }
}

export const wordsOrDate = (date: string) => {
  if (differenceInDays(new Date(), new Date(date)) > 5) {
    return formatDate(date)
  }
  return `${formatDistanceToNowStrict(new Date(date))} ago`
}